export default "__VITE_ASSET__Bnyu1mI5__"